function initSwipers(container = document) {
    document.querySelectorAll('.btb-top-bar .swiper').forEach(function (slider) {
        const autoRotate = slider.dataset.autoRotate === 'true';
        const slidesSpeed = Number(slider.dataset.slidesSpeed) * 1000;

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            speed: 1000,
            autoplay: autoRotate ? {
                delay: slidesSpeed,
                disableOnInteraction: false
            } : false,
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                }
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev')
            }
        });
    });

    document.querySelectorAll('.btb-nav-mobile__panel .swiper').forEach(function (slider) {
        new Swiper(slider, {
            slidesPerView: 1.5,
            spaceBetween: 20,
            loop: false,
            speed: 1000
        });
    });

    document.querySelectorAll('.image-slideshow .swiper').forEach(function (slider) {
        const autoRotate = slider.dataset.autoRotate === 'true';
        const slidesSpeed = Number(slider.dataset.slidesSpeed) * 1000;

        const pagination = slider.querySelector('.swiper-pagination');

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            speed: 1000,
            autoplay: autoRotate ? {
                delay: slidesSpeed,
                disableOnInteraction: false
            } : false,
            pagination: pagination ? {
                el: pagination,
                clickable: true
            } : false
        });
    });

    document.querySelectorAll('.ugc-slider .swiper').forEach(function (slider) {
        const autoRotate = slider.dataset.autoRotate === 'true';
        const slidesSpeed = Number(slider.dataset.slidesSpeed) * 1000;

        const pagination = slider.querySelector('.swiper-pagination');

        new Swiper(slider, {
            slidesPerView: 1.5,
            spaceBetween: 10,
            loop: false,
            speed: 1000,
            autoplay: autoRotate ? {
                delay: slidesSpeed,
                disableOnInteraction: false
            } : false,
            pagination: pagination ? {
                el: pagination,
                clickable: true
            } : false,
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                992: {
                    slidesPerView: 4
                }
            },
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initSwipers();
});

document.addEventListener('shopify:section:load', function (event) {
    if (!(event.target instanceof HTMLElement)) return;

    initSwipers(event.target);
});

/* document.addEventListener('DOMContentLoaded', () => {
    const productGridContainer = document.getElementById('ProductGridContainer');

    if (!productGridContainer) return;

    const bindPagination = () => {
        const paginationLinks = productGridContainer.querySelectorAll('.pagination a[href]');

        paginationLinks.forEach((link) => {
            if (link.dataset.ajaxPagination === 'true') return;

            link.dataset.ajaxPagination = 'true';

            link.addEventListener('click', (event) => {
                event.preventDefault();

                const url = new URL(link.href, window.location.origin);
                const searchParams = url.searchParams.toString();

                FacetFiltersForm.renderPage(searchParams);

                productGridContainer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        });
    };

    bindPagination();

    const observer = new MutationObserver(() => {
        bindPagination();
    });

    observer.observe(productGridContainer, {
        childList: true,
        subtree: true
    });
}); */

document.addEventListener('DOMContentLoaded', () => {
    const productGridContainer = document.getElementById('ProductGridContainer');

    if (!productGridContainer) return;

    const bindPagination = () => {
        const paginationLinks = productGridContainer.querySelectorAll(
            '.pagination--modern a[href]'
        );

        paginationLinks.forEach((link) => {
            if (link.dataset.ajaxPagination === 'true') return;

            link.dataset.ajaxPagination = 'true';

            link.addEventListener('click', async (event) => {
                event.preventDefault();

                const url = new URL(link.href, window.location.origin);
                const searchParams = url.searchParams.toString();

                const currentItems = productGridContainer.querySelectorAll(
                    '.grid__item'
                );

                const currentLastItem = currentItems[currentItems.length - 1];

                const loadingOverlay = document.querySelector(
                    '.collection .loading-overlay'
                );

                // Show loading overlay
                if (loadingOverlay) {
                    loadingOverlay.style.display = 'block';
                }

                try {
                    const response = await fetch(
                        `${window.location.pathname}?${searchParams}`
                    );

                    if (!response.ok) {
                        throw new Error(response.status);
                    }

                    const html = await response.text();

                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    // Get products from the next page
                    const newItems = doc.querySelectorAll(
                        '#ProductGridContainer .grid__item'
                    );

                    // Append new products
                    newItems.forEach((item) => {
                        currentLastItem.insertAdjacentHTML(
                            'afterend',
                            item.outerHTML
                        );
                    });

                    // Replace pagination with the next page pagination
                    const newPagination = doc.querySelector(
                        '.pagination--modern'
                    );

                    const currentPagination = productGridContainer.querySelector(
                        '.pagination--modern'
                    );

                    if (newPagination && currentPagination) {
                        currentPagination.outerHTML = newPagination.outerHTML;
                    } else if (currentPagination) {
                        currentPagination.remove();
                    }

                    // Initialise lazy-loaded images
                    if (window.initLazyImages) {
                        window.initLazyImages();
                    }

                    // Bind the new pagination links
                    bindPagination();
                    
                } catch (error) {
                    console.error(
                        'Unable to fetch pagination results',
                        error
                    );
                } finally {
                    // Hide loading overlay
                    if (loadingOverlay) {
                        loadingOverlay.style.display = 'none';
                    }
                }
            });
        });
    };

    bindPagination();

    const observer = new MutationObserver(() => {
        bindPagination();
    });

    observer.observe(productGridContainer, {
        childList: true,
        subtree: true
    });
});

/* document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.color-swatch');

    if (!swatch) return;

    event.stopPropagation();

    const imageUrl = swatch.dataset.image;

    if (!imageUrl) return;

    const card = swatch.closest('.card-wrapper');
    const image = card?.querySelector('.card__media img');

    if (!image) return;

    // Change image
    image.src = imageUrl;
    image.srcset = imageUrl;

    // Set active swatch
    card.querySelectorAll('.color-swatch').forEach((item) => {
        item.classList.remove('active');
    });

    swatch.classList.add('active');
}); */

document.querySelectorAll('.snippets').forEach((element) => {
    if (element.children.length === 0 && !element.textContent.trim()) {
        element.style.display = 'none';
    }
});

document.addEventListener('DOMContentLoaded', function () {

    const categories = [
        'Kitchen Sinks',
        'Sink Bundles',
        'Kitchen Taps',
        'Kitchen Accessories',
        'Baths',
        'Bath Taps',
        'Bath Accessories',
        'Vanity Units',
        'WC Units',
        'Storage Units',
        'Furniture Accessories',
        'Furniture Packs',
        'Toilets',
        'Basin Taps',
        'Toilet & Basin Accessories',
        'Shower Enclosures',
        'Shower Trays',
        'Shower Kits',
        'Shower Valves',
        'Shower Accessories',
        'Wetroom',
        'Tower Rails',
        'Radiators',
        'Heating Accessories',
        'Mirror Cabinets',
        'LED Mirrors',
        'Bathroom Suites',
        'Cloakroom Suites'
    ];

    const compareItems = document.querySelectorAll('.compare-it');

    // Load selected products from localStorage
    window.selectedProducts = JSON.parse(
        localStorage.getItem('selectedProducts') || '[]'
    );


    // ----------------------------------------
    // RESTORE CHECKED CHECKBOXES
    // ----------------------------------------

    compareItems.forEach(item => {

        const checkbox = item.querySelector(
            'input[type="checkbox"]'
        );

        if (!checkbox) return;

        const isSelected = window.selectedProducts.some(
            product => product.value === checkbox.value
        );

        if (isSelected) {
            checkbox.checked = true;
        }

    });


    // ----------------------------------------
    // CHECKBOX EVENTS
    // ----------------------------------------

    compareItems.forEach(item => {

        const checkbox = item.querySelector(
            'input[type="checkbox"]'
        );

        if (!checkbox) return;


        checkbox.addEventListener('change', function () {

            const value = this.value;
            const type = this.dataset.type || '';


            // Find matching category
            const matchedCategory = categories.find(category =>
                type.includes(category)
            );

            if (!matchedCategory) return;


            // ----------------------------------------
            // CHECK CATEGORY LIMIT
            // ----------------------------------------

            if (this.checked) {

                const categoryCount =
                    window.selectedProducts.filter(
                        product =>
                            product.category === matchedCategory
                    ).length;


                // Maximum 4 products per category
                if (categoryCount >= 4) {

                    this.checked = false;


                    // Remove existing message
                    const existingMessage =
                        item.querySelector(
                            '.compare-limit-message'
                        );

                    if (existingMessage) {
                        existingMessage.remove();
                    }


                    // Create message
                    const message =
                        document.createElement('div');

                    message.className =
                        'compare-limit-message';

                    message.textContent =
                        'You can only compare 4 items per category.';

                    item.appendChild(message);


                    // Fade out after 1.7 seconds
                    setTimeout(() => {

                        message.classList.add('fade-out');

                        setTimeout(() => {
                            message.remove();
                        }, 300);

                    }, 1700);


                    return;
                }


                // ----------------------------------------
                // ADD PRODUCT
                // ----------------------------------------

                const alreadySelected =
                    window.selectedProducts.some(
                        product =>
                            product.value === value
                    );


                if (!alreadySelected) {

                    window.selectedProducts.push({
                        value: value,
                        category: matchedCategory
                    });

                }

            } else {

                // ----------------------------------------
                // REMOVE PRODUCT
                // ----------------------------------------

                window.selectedProducts =
                    window.selectedProducts.filter(
                        product =>
                            product.value !== value
                    );

            }


            // ----------------------------------------
            // SAVE TO LOCAL STORAGE
            // ----------------------------------------

            localStorage.setItem(
                'selectedProducts',
                JSON.stringify(
                    window.selectedProducts
                )
            );


            // ----------------------------------------
            // UPDATE COMPARISON COUNT
            // ----------------------------------------

            updateComparisonCount();

        });

    });

    updateComparisonCount();

});

function clearSelectedProducts() {
    window.selectedProducts = [];

    localStorage.removeItem('selectedProducts');

    document.querySelectorAll(
        '.compare-it input[type="checkbox"]'
    ).forEach(checkbox => {
        checkbox.checked = false;
    });

    console.log(
        'Selected products cleared:',
        window.selectedProducts
    );
}

async function fetchProductComparison(handle) {
    try {
        const response = await fetch(`/products/${handle}`);

        if (!response.ok) {
            throw new Error(`Failed to fetch ${handle}`);
        }

        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const comparison = doc.querySelector('.get-on-comparison');

        if (!comparison) {
            return null;
        }

        const sections = [];

        comparison
            .querySelectorAll('.btb-detail-col__subhead')
            .forEach(heading => {
                const sectionName = heading.textContent.trim();
                const table = heading.nextElementSibling;

                if (!table || !table.matches('table')) {
                    return;
                }

                const rows = [];

                table.querySelectorAll('tr').forEach(row => {
                    const label = row
                        .querySelector('th')
                        ?.textContent
                        .trim();

                    const value = row
                        .querySelector('td')
                        ?.textContent
                        .trim();

                    if (label && value) {
                        rows.push({
                            label: label,
                            value: value
                        });
                    }
                });

                sections.push({
                    name: sectionName,
                    rows: rows
                });
            });

        const title = doc.querySelector('h1')?.textContent.trim() || handle;

        const image = doc.querySelector(
            '.product__media img, .product-gallery img'
        )?.src || '';

        const price = doc.querySelector(
            '.price, .product-price'
        )?.textContent.trim() || '';

        return {
            handle,
            title,
            image,
            price,
            url: `/products/${handle}`,
            sections
        };
    } catch (error) {
        console.error(`Error fetching ${handle}:`, error);
        return null;
    }
}

function getComparisonSections(products) {
    const sections = [];

    products.forEach(product => {
        product.sections.forEach(section => {
            const exists = sections.some(
                existing => existing.name === section.name
            );

            if (!exists) {
                sections.push({
                    name: section.name
                });
            }
        });
    });

    return sections;
}

async function fetchSelectedProducts() {
    const products = await Promise.all(
        window.selectedProducts.map(product =>
            fetchProductComparison(product.value)
                .then(result => {
                    if (!result) {
                        return null;
                    }

                    return {
                        ...result,
                        category: product.category
                    };
                })
        )
    );

    return products.filter(Boolean);
}

function groupProductsByCategory(products) {
    return products.reduce((groups, product) => {
        if (!groups[product.category]) {
            groups[product.category] = [];
        }

        groups[product.category].push(product);

        return groups;
    }, {});
}

function renderComparisonTabs(products) {
    const tabsContainer = document.querySelector('.comparison-tabs');
    const contentContainer = document.querySelector(
        '.comparison-tab-content'
    );

    if (!tabsContainer || !contentContainer) {
        return;
    }

    tabsContainer.innerHTML = '';
    contentContainer.innerHTML = '';

    const groupedProducts = groupProductsByCategory(products);
    const categories = Object.keys(groupedProducts);

    categories.forEach((category, index) => {
        const productsInCategory = groupedProducts[category];

        const tab = document.createElement('button');

        tab.type = 'button';
        tab.className = 'comparison-tab';
        tab.dataset.category = category;
        tab.textContent = `${category} (${productsInCategory.length})`;

        if (index === 0) {
            tab.classList.add('active');
        }

        tabsContainer.appendChild(tab);

        const content = document.createElement('div');

        content.className = 'comparison-category';
        content.dataset.category = category;

        if (index !== 0) {
            content.hidden = true;
        }

        contentContainer.appendChild(content);

        renderCategoryComparison(
            content,
            category,
            productsInCategory
        );
    });

    tabsContainer.querySelectorAll('.comparison-tab').forEach(tab => {
        tab.addEventListener('click', function () {
            const category = this.dataset.category;

            tabsContainer
                .querySelectorAll('.comparison-tab')
                .forEach(item => {
                    item.classList.toggle(
                        'active',
                        item === this
                    );
                });

            contentContainer
                .querySelectorAll('.comparison-category')
                .forEach(content => {
                    content.hidden =
                        content.dataset.category !== category;
                });
        });
    });
}

function renderCategoryComparison(container, category, products) {
    const sections = getComparisonSections(products);

    const wrapper = document.createElement('div');

    wrapper.className = 'comparison-table-wrapper';

    // Product header table
    const productTable = document.createElement('table');

    productTable.className =
        'comparison-table comparison-products';

    const productBody = document.createElement('tbody');

    const productRow = document.createElement('tr');

    // Empty label cell
    const emptyCell = document.createElement('th');

    productRow.appendChild(emptyCell);

    // Add selected products
    products.forEach(product => {
        const productCell = document.createElement('td');

        productCell.className = 'comparison-product';

        // Product link
        const productLink = document.createElement('a');

        productLink.href = `/products/${product.handle}`;

        productLink.className =
            'comparison-product__link';

        // Product image
        if (product.image) {
            const image = document.createElement('img');

            image.src = product.image;
            image.alt = product.title;
            image.loading = 'lazy';

            productLink.appendChild(image);
        }

        // Product title
        const title = document.createElement('span');

        title.className =
            'comparison-product__title';

        title.textContent = product.title;

        productLink.appendChild(title);

        productCell.appendChild(productLink);

        // Remove button
        const removeButton = document.createElement('button');

        removeButton.type = 'button';

        removeButton.className =
            'comparison-product__remove';

        removeButton.dataset.handle = product.handle;

        removeButton.setAttribute(
            'aria-label',
            `Remove ${product.title} from comparison`
        );

        removeButton.innerHTML = `
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
            >
                <path d="M6 6L18 18"></path>
                <path d="M18 6L6 18"></path>
            </svg>
        `;

        productCell.appendChild(removeButton);

        productRow.appendChild(productCell);
    });

    // Fill remaining product columns
    for (let i = products.length; i < 4; i++) {
        const emptyProductCell =
            document.createElement('td');

        emptyProductCell.className =
            'comparison-product--empty';

        productRow.appendChild(emptyProductCell);
    }

    productBody.appendChild(productRow);

    productTable.appendChild(productBody);

    wrapper.appendChild(productTable);

    // Comparison sections
    sections.forEach(section => {
        const sectionHeading =
            document.createElement('h3');

        sectionHeading.textContent = section.name;

        wrapper.appendChild(sectionHeading);

        const table = document.createElement('table');

        table.className = 'comparison-table';

        const tbody = document.createElement('tbody');

        const labels = [];

        // Get all unique labels for this section
        products.forEach(product => {
            const productSection =
                product.sections.find(
                    item => item.name === section.name
                );

            if (!productSection) {
                return;
            }

            productSection.rows.forEach(row => {
                if (!labels.includes(row.label)) {
                    labels.push(row.label);
                }
            });
        });

        // Create comparison rows
        labels.forEach(label => {
            const tr = document.createElement('tr');

            // Label cell
            const labelCell =
                document.createElement('th');

            labelCell.textContent = label;

            tr.appendChild(labelCell);

            // Product values
            products.forEach(product => {
                const td =
                    document.createElement('td');

                const productSection =
                    product.sections.find(
                        item => item.name === section.name
                    );

                const row =
                    productSection?.rows.find(
                        item => item.label === label
                    );

                td.textContent =
                    row?.value || '—';

                tr.appendChild(td);
            });

            // Fill remaining product columns
            for (let i = products.length; i < 4; i++) {
                const emptyValueCell =
                    document.createElement('td');

                emptyValueCell.className =
                    'comparison-empty-cell';

                emptyValueCell.textContent = '—';

                tr.appendChild(emptyValueCell);
            }

            tbody.appendChild(tr);
        });

        table.appendChild(tbody);

        wrapper.appendChild(table);
    });

    container.appendChild(wrapper);
}

async function initComparison() {
    const highlightDifferences = document.querySelector(
        '#highlight-differences'
    );

    if (highlightDifferences) {
        highlightDifferences.checked = false;
    }

    const comparison = document.querySelector('.comparison');

    if (!comparison) {
        return;
    }

    comparison.classList.add('is-loading');

    // Allow the loading overlay to render
    await new Promise(resolve => {
        requestAnimationFrame(resolve);
    });

    try {
        const tabsContainer = document.querySelector(
            '.comparison-tabs'
        );

        const contentContainer = document.querySelector(
            '.comparison-tab-content'
        );

        if (!tabsContainer || !contentContainer) {
            return;
        }

        tabsContainer.innerHTML = '';
        contentContainer.innerHTML = '';

        if (!window.selectedProducts?.length) {
            return;
        }

        const products = await fetchSelectedProducts();

        if (!products.length) {
            return;
        }

        renderComparisonTabs(products);

        initComparisonDifferenceHighlight();

    } finally {
        comparison.classList.remove('is-loading');
    }
}

function toggleComparisonDifferences() {
    const checkbox = document.querySelector(
        '#highlight-differences'
    );

    if (!checkbox) {
        return;
    }

    document
        .querySelectorAll('.comparison-table tbody tr')
        .forEach(row => {
            const values = Array.from(
                row.querySelectorAll('td:not(.comparison-empty-cell)')
            ).map(cell => cell.textContent.trim());

            const hasDifference =
                values.length > 1 &&
                values.some(value => value !== values[0]);

            row.classList.toggle(
                'highlight',
                checkbox.checked && hasDifference
            );
        });
}

function initComparisonDifferenceHighlight() {
    const checkbox = document.querySelector(
        '#highlight-differences'
    );

    if (!checkbox) {
        return;
    }

    checkbox.addEventListener(
        'change',
        toggleComparisonDifferences
    );
}

document.addEventListener('click', function (event) {
    const removeButton = event.target.closest(
        '.comparison-product__remove'
    );

    if (!removeButton) {
        return;
    }

    event.preventDefault();
    event.stopPropagation();

    const handle = removeButton.dataset.handle;

    // Remove from selected products
    window.selectedProducts =
        window.selectedProducts.filter(
            item => item.value !== handle
        );

    // Update localStorage
    localStorage.setItem(
        'selectedProducts',
        JSON.stringify(
            window.selectedProducts
        )
    );

    // Update comparison count
    updateComparisonCount();

    // Uncheck the checkbox
    const checkbox = document.querySelector(
        `.compare-it input[type="checkbox"][value="${handle}"]`
    );

    if (checkbox) {
        checkbox.checked = false;
    }

    // Find the product cell
    const productCell = removeButton.closest(
        '.comparison-product'
    );

    if (!productCell) {
        return;
    }

    // Find the product header table
    const productTable = productCell.closest(
        '.comparison-products'
    );

    if (!productTable) {
        return;
    }

    // Find the category wrapper
    const categoryContainer = productTable.closest(
        '.comparison-category'
    );

    if (!categoryContainer) {
        return;
    }

    // Get the product column index
    const productRow = productCell.parentElement;

    const productIndex = Array.from(
        productRow.children
    ).indexOf(productCell);

    /*
     * Move all cells after the removed product
     * one position to the left.
     */
    const headerCells = Array.from(
        productRow.children
    );

    for (
        let i = productIndex;
        i < headerCells.length - 1;
        i++
    ) {
        const currentCell = headerCells[i];
        const nextCell = headerCells[i + 1];

        currentCell.replaceWith(
            nextCell.cloneNode(true)
        );
    }

    /*
     * Rebuild the final header cell as an
     * empty product cell.
     */
    const finalHeaderCell =
        productRow.lastElementChild;

    finalHeaderCell.innerHTML = '';

    finalHeaderCell.className =
        'comparison-product--empty';

    /*
     * Move comparison values left in the
     * same way for every comparison table.
     */
    categoryContainer
        .querySelectorAll(
            '.comparison-table:not(.comparison-products)'
        )
        .forEach(table => {

            table.querySelectorAll(
                'tbody tr'
            ).forEach(row => {

                const cells = Array.from(
                    row.children
                );

                /*
                 * Move every cell after the removed
                 * product one position to the left.
                 */
                for (
                    let i = productIndex;
                    i < cells.length - 1;
                    i++
                ) {
                    const currentCell = cells[i];
                    const nextCell = cells[i + 1];

                    currentCell.replaceWith(
                        nextCell.cloneNode(true)
                    );
                }

                /*
                 * Make the final product column empty.
                 */
                const finalCell =
                    row.lastElementChild;

                finalCell.textContent = '—';

                finalCell.className =
                    'comparison-empty-cell';
            });
        });

    // Count remaining actual products
    const productCount =
        categoryContainer.querySelectorAll(
            '.comparison-products .comparison-product'
        ).length;

    const category =
        categoryContainer.dataset.category;

    // Find category tab
    const tab = document.querySelector(
        `.comparison-tab[data-category="${category}"]`
    );

    if (productCount > 0) {

        // Update category counter
        if (tab) {
            tab.textContent =
                `${category} (${productCount})`;
        }

        return;
    }

    // No products left in this category
    if (tab) {
        tab.remove();
    }

    categoryContainer.remove();

    // Activate first remaining tab
    const firstTab = document.querySelector(
        '.comparison-tab'
    );

    if (firstTab) {
        firstTab.click();
    }
});

document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.comparison .toggle');

    if (!toggle) {
        return;
    }

    const comparison = toggle.closest('.comparison');

    if (!comparison) {
        return;
    }

    comparison.classList.toggle('open');

    document.body.style.overflow =
        comparison.classList.contains('open')
            ? 'hidden'
            : '';

    if (comparison.classList.contains('open')) {
        initComparison();
    }
});

function updateComparisonCount() {
    const countElement = document.querySelector(
        '.comparison-header span'
    );

    const comparison = document.querySelector(
        '.comparison'
    );

    if (!countElement || !comparison) {
        return;
    }

    const count =
        window.selectedProducts?.length || 0;

    countElement.textContent = count;

    if (count === 0) {
        comparison.className = 'comparison';
         document.body.style.overflow = '';
    }

    if (count > 0) {
        comparison.classList.add('visible');
    }

    // Uncheck highlight differences
    const highlightDifferences = document.querySelector(
        '#highlight-differences'
    );

    if (highlightDifferences) {
        highlightDifferences.checked = false;
    }

    // Remove highlights
    document
        .querySelectorAll('.comparison-table tbody tr.highlight')
        .forEach(row => {
            row.classList.remove('highlight');
        });
}